import ajax from "../ajax";
export default {
  name: "StaticPage",
  props: {
    page: String
  },

  data() {
    return {
      loaded: false
    };
  },

  watch: {
    "$i18n.locale": function () {
      this.tryLoadLocale();
    }
  },
  methods: {
    tryLoadLocale() {
      let locale = this.$i18n.locale;
      let pageName = this.page || this.$route.page;
      let messages = this.$i18n.messages[locale];

      if (messages && messages["static"] && messages["static"][pageName]) {
        return;
      }

      ajax.get("/locale", {
        id: locale,
        static: pageName
      }).then(response => {
        this.$i18n.mergeLocaleMessage(locale, response.data.content[locale]);
        this.$i18n.locale = '';
        this.$i18n.locale = locale;
        this.loaded = true;
      });
    }

  },

  created() {
    this.tryLoadLocale();
  }

};